import { Injectable } from '@angular/core';
import { Variant } from '../models/variant.model';
import { Project } from '../models/project.model';
import { Region, RegionWithState, RegionData } from '../models/region.model';
import { Wagon } from '../models/wagon.model';
import { UpdateUser, User } from '../models/user.model';
import { Company } from '../models/company.model';
import { TravelMix } from '../models/TravelMix.model';
import { VariantEvaluationViewParameters } from '../models/VariantEvaluationViewParameters.model';
import { GraphicSettings } from '../models/GraphicSettings.model';
import { RegionUpdated } from '../models/RegionUpdated.model';
import { VariantEvaluationFrontendParameter } from '../models/VariantEvaluationFrontendParameter.model';
import { UserCredentials } from '../models/Credentials.model';
import { InteriorObject } from '../models/interior-object.model';
import { PublishStateRegion } from '../models/PublishStateRegion.model';
import { OverrideEmail } from '../models/OverrideEmail.model';
import { EditorInformation } from '../models/EditorInformation.model';
import { RequestServiceBase } from './request.base';
import { MasterData } from '../models/masterData.model';
import { Observable } from 'rxjs';
import { TrainEvaluationFrontendParameter } from '../models/TrainEvaluationFrontendParameter.model';
import { UserValidationRequest } from '../models/UserValidationRequest.model';
import { UserValidationResult } from '../models/UserValidationResult.model';
import { CreateUserRequest } from '../models/CreateUserRequest.model';

@Injectable({providedIn:'root'})
export class RequestService extends RequestServiceBase {

  // Wagon
  public getWagons(projectId: number) {
    const action = 'GetWagons';
    const param = action + this.routeSeperator + projectId;
    return this.getAll<Wagon>(action, param, this.wagonEndpoint);
  }
  public getWagon(wagonId: number) {
    const action = 'GetWagon';
    const param = action + this.routeSeperator + wagonId;
    return this.getOne<Wagon>(action, param, this.wagonEndpoint);
  }
  public writeWagon(wagonFormValue: any) {
    const action = this.writeAction;
    return this.post<Wagon>(action, wagonFormValue, this.wagonEndpoint);
  }
  public deleteWagon(wagonTypeID) {
    const action = this.deleteAction;
    const param = action + this.routeSeperator + wagonTypeID;

    return this.delete(action, param, this.wagonEndpoint);
  }
  public getToolBoxItems() {
    const action = 'GetToolBoxItems';
    const param = action;
    return this.getAll<InteriorObject>(action, param, this.wagonEndpoint);
  }
  // Train
  public getTrains(projectId: number) {
    const action = 'GetTrains';
    const param = action + this.routeSeperator + projectId;
    return this.getAll<any>(action, param, this.trainEndpoint);

  }
  public deleteTrain(traindId) {
    const action = 'DeleteTrain';
    const param = action + this.routeSeperator + traindId;
    return this.delete(action, param, this.trainEndpoint);
  }
  public copyTrain(data: any) {
    const action = 'CopyTrain';
    const param = data;
    return this.post<any[]>(action, param, this.trainEndpoint);
  }
  public writeTrain(data: any) {
    const action = 'WriteTrain';
    const param = data;
    return this.post<any[]>(action, param, this.trainEndpoint);
  }
  public getTrainsForEvaluation(projectId: number) {
    const action = 'GetTrainsForEvaluationView';
    const param = action + this.routeSeperator + projectId;
    return this.getAll<any>(action, param, this.trainEndpoint);
  }
  public GetVariantsWithDoorsFromTrain(traindId: number) {
    const action = 'GetVariantsWithDoorsFromTrain';
    const param = action + this.routeSeperator + traindId;
    return this.getAll<any>(action, param, this.trainEndpoint);
  }
  // user
  public Authenticate(credentials: UserCredentials) {
    const action = 'Authenticate';
    return this.post<any>(action, credentials, this.userEndpoint);
  }
  public refreshToken(credentials: UserCredentials) {
    const action = 'RefreshToken';
    return this.post<any>(action, credentials, this.userEndpoint);
  }
  public createUser(user: CreateUserRequest) {
    const action = 'CreateUser';
    return this.post<UpdateUser>(action, user, this.userEndpoint);
  }
  public overridePassword(credentials: UserCredentials) {
    const action = 'UpdateUserPassword';
    return this.post<any>(action, credentials, this.userEndpoint);
  }
  public setUserIsBusinessActive(credentials: UserCredentials) {
    const action = 'SetUserIsBusinessActive';
    return this.post<any>(action, credentials, this.userEndpoint);
  }
  public deleteUser(userId: number) {
    const action = 'DeleteUser';
    const param = action + this.routeSeperator + userId;
    return this.delete<any>(action, param, this.userEndpoint);
  }
  public overrideEmail(emails: OverrideEmail) {
    const action = 'UpdateUserEmail';
    return this.post<any>(action, emails, this.userEndpoint);
  }
  public getUsers(roleId: number, companyId: number, userIdForFilter: number) {
    const action = 'GetUsers';
    let param = action + this.routeSeperator + roleId + this.routeSeperator + companyId + this.routeSeperator + userIdForFilter;
    return this.getAll<User>(action, param, this.userEndpoint);
  }
  public validateUser(userValidationrequest: UserValidationRequest) {
    const action = "ValidateUser";
    return this.post<UserValidationResult>(action, userValidationrequest, this.userEndpoint);
  }
  public maxActiveUsersReached(companyId: number) {
    const action = "MaxActiveUsersReached";
    const param = action + this.routeSeperator + companyId;
    return this.getOne<boolean>(action, param, this.userEndpoint);
  }

  // Company
  public getActiveAndBusinessActiveCompaniesWithoutSystemCompanyForAddUserDropdown() {
    const action = 'GetActiveAndBusinessActiveCompaniesWithoutSystemCompanyForAddUserDropdown';
    let param = action;
    return this.getAll<Company>(action, param, this.companyEndpoint);
  }
  public getActiveCompaniesWithoutSystemCompanyForCompanyListView() {
    const action = 'GetActiveCompaniesWithoutSystemCompanyForCompanyListView';
    let param = action;
    return this.getAll<Company>(action, param, this.companyEndpoint);
  }
  public getCompany(companyId: number) {
    const action = 'GetCompany';
    const param = action + this.routeSeperator + companyId;
    return this.getOne<Company>(action, param, this.companyEndpoint)
  }
  public writeCompany(companyFromValue) {
    const action = this.writeAction;
    return this.post<Company>(action, companyFromValue, this.companyEndpoint);
  }
  public deleteCompany(companyId: number) {
    const action = this.deleteAction;
    const param = action + this.routeSeperator + companyId;
    return this.delete(action, param, this.companyEndpoint);
  }
  public deactivateCompany(companyId: number) {
    const action = 'DeactivateCompany';
    const param = action + this.routeSeperator + companyId;
    return this.getOne(action, param, this.companyEndpoint);
  }
  public activateCompany(companyId: number) {
    const action = 'ActivateCompany';
    const param = action + this.routeSeperator + companyId;
    return this.getOne(action, param, this.companyEndpoint);
  }
  public getCompanyRegions(companyId: number) {
    const action = 'GetCompanyRegions';
    const param = action + this.routeSeperator + companyId;
    return this.getAll<Region>(action, param, this.companyEndpoint);
  }
  public getGraphicSettings(companyId: number) {
    const action = 'GetGraphicSettings'; const param = action + this.routeSeperator + companyId;
    return this.getOne<GraphicSettings>(action, param, this.companyEndpoint);
  }

  // Project
  public getProjects(companyID: number) {
    const action = 'GetProjects'; const param = action + this.routeSeperator + companyID;
    return this.getAll<Project>(action, param, this.projectEndpoint)
  }
  public getProjectById(projectId: number) {
    const action = 'GetProject';
    const param = action + this.routeSeperator + projectId;
    return this.getOne<Project>(action, param, this.projectEndpoint);
  }
  public writeProject(project: Project) {
    const action = this.writeAction;
    return this.post<Project>(action, project, this.projectEndpoint);
  }
  public deleteProject(projectID: number): Observable<any> {
    const action = this.deleteAction;
    const item = projectID;
    return this.post(action, item, this.projectEndpoint)
  }
  public getAdvancedSettings(project: Project) {
    const action = 'GetAdvancedSettings';
    return this.post(action, project, this.projectEndpoint);
  }

  // Variant
  public getVariant(variantId: number) {
    const action = 'GetVariant';
    const param = action + this.routeSeperator + variantId;
    return this.getOne<Variant>(action, param, this.variantEndpoint);
  }
  public getVariants(wagonId: number) {
    const action = 'GetVariants';
    const param = action + this.routeSeperator + wagonId;
    return this.getAll<Variant>(action, param, this.variantEndpoint);
  }
  public getVariantWithDoors(variantId: number) {
    const action = 'GetVariantWithDoors';
    const param = action + this.routeSeperator + variantId;
    return this.getOne<VariantEvaluationViewParameters>(action, param, this.variantEndpoint);
  }
  public deleteVariant(variantID: number): Observable<any> {
    const action = this.deleteAction;
    const item = variantID;
    return this.post(action, item, this.variantEndpoint);
  }
  public writeVariant(variant: Variant) {
    const action = 'WriteVariant';
    return this.post(action, variant, this.variantEndpoint);
  }
  public GetEditorInformation(variantId: number) {
    const action = 'GetEditorInformation';
    const param = action + this.routeSeperator + variantId;
    return this.getOne<EditorInformation>(action, param, this.variantEndpoint);
  }

  // evaluation
  public evaluateVariant(param: VariantEvaluationFrontendParameter) {
    const action = 'EvaluateVariant';
    return this.blobResponse(action, param, this.evaluationEndpoint);
  }

  public evaluateTrain(param: TrainEvaluationFrontendParameter) {
    const action = 'EvaluateTrain';
    return this.blobResponse(action, param, this.evaluationEndpoint);
  }

  // passanger behaviour data
  public getRegionData(regionId: number) {
    const action = 'GetRegionData'; const param = action + this.routeSeperator + regionId;
    return this.getOne<RegionData>(action, param, this.passengerBehaviourEndpoint);
  }
  public writeRegionData(regionData: RegionUpdated) {
    const action = 'WriteRegionData';
    return this.post(action, regionData, this.passengerBehaviourEndpoint);
  }
  public copyRegion(region: Region) {
    const action = 'CopyRegion';
    return this.post(action, region, this.passengerBehaviourEndpoint);
  }
  public setAsDefaultRegion(regionId: number) {
    const action = 'SetAsDefaultRegion';
    return this.post(action, regionId, this.passengerBehaviourEndpoint);
  }
  public changePublishStateOfRegion(publishStateRegion: PublishStateRegion) {
    const action = 'ChangePublishStateOfRegion';
    return this.post(action, publishStateRegion, this.passengerBehaviourEndpoint);
  }
  public getTravelMixes(regionId: number, transportModeId: number) {
    const action = 'GetTravelMixes';
    const param = action + this.routeSeperator + regionId + this.routeSeperator + transportModeId;
    return this.getAll<TravelMix>(action, param, this.passengerBehaviourEndpoint);
  }
  public getRegions() {
    const action = 'GetRegions'; const param = action;
    return this.getAll<Region>(action, param, this.passengerBehaviourEndpoint);
  }
  public getRegionsWithState() {
    const action = 'GetRegionsWithStates'; const param = action;
    return this.getAll<RegionWithState>(action, param, this.passengerBehaviourEndpoint);
  }

  // Master data requests
  public getMasterData() {
    const action = 'GetMasterData'; const param = action;
    return this.getOne<MasterData>(action, param, this.masterdataEndpoint);
  }
}